import { useState } from "react";
import {
  TextField,
  Button,
  Stack,
  Card,
  Typography,
  Box,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { createProject } from "../Servies/AdmiServices";

export default function CreateProject() {
  const [name, setName] = useState("");
  const [deadline, setDeadline] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // --- Handle Project Submission ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !deadline) {
      toast.error("Please fill all fields");
      return;
    }

    setIsLoading(true);

    try {
      const data = { name, deadline };
      const res = await createProject(data);

      if (res.data?.status === "SUCCESS") {
        toast.success(res.data?.message || "Project created successfully!");
        setTimeout(() => {
          navigate("/dashboard/projectlist")
        }, 1500);
        setName("");
        setDeadline("");
      } else {
        toast.error(res.data?.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Error creating project");
    } finally {
      setIsLoading(false);
    }
  };

  // --- Handle Cancel ---
  const handleCancel = () => {
    navigate("/dashboard/projectlist");
  };

  return (
    <>
      <ToastContainer />

      {/* --- Back Button --- */}
      <Box sx={{ padding: "20px 40px" }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
          sx={{
            borderColor: "#ccc",
            "&:hover": { borderColor: "#888" },
          }}
        >
          ← Back 
        </Button>
      </Box>

      {/* --- Form Card --- */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "20px",
        }}
      >
        <Card
          sx={{
            width: "90%",
            maxWidth: "500px",
            padding: "30px",
            backgroundColor: "#fff",
            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1)",
            borderRadius: "16px",
          }}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            mb={4}
            textAlign="center"
          >
            Create New Project
          </Typography>

          {/* --- Form Section --- */}
          <form onSubmit={handleSubmit}>
            <Stack direction="column" spacing={3}>
              <TextField
                label="Project Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />

              <TextField
                label="Deadline"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
                fullWidth
              />

              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isLoading}
                  sx={{
                    height: "45px",
                    px: 2.5,
                    backgroundColor: "#1976d2",
                    "&:hover": { backgroundColor: "#115293" },
                  }}
                >
                  {isLoading ? "Creating..." : "Create"}
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleCancel}
                  sx={{
                    height: "45px",
                    px: 2.5,
                    borderColor: "#f44336",
                    color: "#f44336",
                    "&:hover": { backgroundColor: "#fdecea" },
                  }}
                >
                  Cancel
                </Button>
              </Stack>
            </Stack>
          </form>
        </Card>
      </Box>
    </>
  );
}
